import { useTranslation } from 'react-i18next';
import { Widget } from '@asset-metrix/portal-ui';
import { Stack } from '@mantine/core';

import {
  InvestmentComplianceLimitDataLevel,
  LimitSetupDraft,
} from './createInvestmentLimitModel';
import { ReviewSummary } from './ReviewSummary';

import styles from './createInvestmentLimitModal.module.scss';

export type ReviewStepProps = {
  contentId: string;
  dataLevels: InvestmentComplianceLimitDataLevel[];
  draft: LimitSetupDraft;
};

export function ReviewStep({ contentId, dataLevels, draft }: ReviewStepProps) {
  const { t } = useTranslation();

  return (
    <Stack className={styles['modal-step']}>
      <Widget title={t('app.investmentLimit.widgets.review')}>
        <div className={styles['modal-card-content']}>
          <ReviewSummary
            contentId={contentId}
            dataLevels={dataLevels}
            draft={draft}
          />
        </div>
      </Widget>
    </Stack>
  );
}
